export default __webpack_public_path__ + "static/kalbe-logo-93ddbb8bd4d0905a38da48ea450ebf53.png";